import React from 'react';
import { formatDisplayError } from '../../../utils/passwordValidation';

const FormFieldError = ({ message }) => {
  if (!message) return null;
  const text = formatDisplayError(message);
  if (!text) return null;
  return (
    <span
      className="text-red-500 form-field-error"
      style={{ fontSize: '11px', display: 'block', marginTop: '4px' }}
      role="alert"
    >
      {text}
    </span>
  );
};

export default FormFieldError;
